export const Shape = {
    rectangle: 0,
    circle: 1
};

export const Type = {
    texture: 0,
    text: 1
};

export const MovementBehaviour = {
    none: 0,
    to: 1,
    backAndForth: 2,
    flee: 3,
    approach: 4,
    free: 5
};

export const RotationBehaviour = {
    none: 0,
    continous: 1,
    once: 2,
    backAndForth: 3,
    free: 4
};

export const RotationDirection = {
    left: 0,
    right: 1
};

export const ResizeBehaviour = {
    none: 0,
    once: 1,
    backAndForth: 2
};

export const ViewDirection = {
    Side: 0,
    TopDown: 1
};

export const ReactionAfterwards = {
    StayTheSame: 0,
    Disappear: 1,
    ChangeState: 2
};

export const playerSettings = {
    livesMin: 1,
    livesMax: 10,
    livesDefault: 5,
    livesStep: 1,

    weightMin: 2,
    weightMax: 15,
    weightDefault: 6,
    weightStep: 1,

    bounceMin: 0,
    bounceMax: 100,
    bounceDefault: 0,
    bounceStep: 1,
    bounceStepSlider: 5,

    hatDefault: 'pet',
    textureDefault: 'kaas',
    textureHue: 0,
    textureHueMin: 0,
    textureHueMax: 360,
    textureHueStep: 1,

    normalizeBounce(bounce) {
        return bounce / playerSettings.bounceMax;
    },

    denormalizeBounce(bounce) {
        return bounce * playerSettings.bounceMax;
    }
};

export const levelSettings = {
    title: 'Level',
    description: '...'
};

export const blokSettings = {
    // Blok state look
    type: Type.texture,
    data: {
        // Texture
        value: '',
        hue: 0,
        // Text
        text: '',
        color: 16777215, // white
        size: 24
    },
    textValue: 'tekst',

    // Blok settings
    shape: Shape.rectangle,
    stateIndex: 0,
    thingsMoveThroughMe: false,
    friction: 0.5,
    bounce: 0.1,
    weight: 10,
    speed: 4,
    movementBehaviour: MovementBehaviour.none,
    rotationBehaviour: RotationBehaviour.none,
    rotationDirection: RotationDirection.right,
    rotationSpeed: 1,
    rotationAngle: 0,
    resizeBehaviour: ResizeBehaviour.none,
    resizeSpeed: 1,
    resizeWidth: 1,
    resizeHeight: 1,

    // Stays different
    changesBack: false,
    changeBackTime: 0.1
};

export const actionReactionSettings = {
    respondToPlayerCollision: false,
    respondToObjectCollision: false,
    points: 0,
    health: 0,
    sound: '',
    passOnReaction: '',
    toLevel: false,
    afterwards: ReactionAfterwards.StayTheSame
};

export const RecentsCategoryString = 'recent';

export const BackgroundCategoryString = 'background';

export const newStateObject = {
    texture: 'wall',
    hue: 0
};
